module.exports = __webpack_public_path__ + "static/Pianeta_new_ats_6-c8d6937f692fdcb1341599b731593e98.svg";